import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../component/form/form-layout";

const htmlToText = (html = "") => {
  return html
    .replace(/\t/g, "") // remove tabs
    .replace(/\r/g, "") // remove carriage returns
    .replace(/<\/li>/gi, "\n") // li end → newline
    .replace(/<br\s*\/?>/gi, "\n") // br → newline
    .replace(/<[^>]*>/g, "") // remove all other HTML tags
    .replace(/&amp;/g, "&") // decode &amp;
    .replace(/\n\s*\n+/g, "\n") // remove multiple empty lines
    .trim(); // trim start/end
};

const AddUpdatePackage = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  packageData = null,
  Style,
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const metas = Object.fromEntries(
    packageData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? [],
  );

  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const initialMainId = packageData?.main_product
    ? Number(packageData.main_product.parent_id)
    : null;
  const initialSubId = packageData?.sub_product_id
    ? Number(packageData.sub_product_id)
    : null;
  const initialPackageId = packageData?.deal_package
    ? Number(metas.deal_package)
    : null;
  const [projectList, setProjectList] = useState([]);
  const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

  // console.log("packageData", packageData)

  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        if (initialSubId) {
          loadPackages(initialSubId);
        }
      });
    } else if (initialSubId) {
      loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  useEffect(() => {
    if (packageData?.packageid) {
      console.log("package", packageData);

      formik.setFieldValue("packagename", packageData?.packagename);
      formik.setFieldValue("amount", packageData?.amount);
      formik.setFieldValue("discount", packageData?.discount);
      formik.setFieldValue("oldprice", packageData?.oldprice);
      formik.setFieldValue("tagline", packageData?.tagline);
      formik.setFieldValue("numberofrevisions", packageData?.numberofrevisions);
      formik.setFieldValue("concepts", packageData?.concepts);
      formik.setFieldValue("show_pkg", packageData?.show_pkg);
      formik.setFieldValue("features", htmlToText(packageData.features || ""));
    }
  }, []);

  const validationSchema = yup.object({
    main_product: yup.number().required("This Field is Required"),
    // sub_product_id: yup.number().required("This Field is Required"),
    sub_product_id: yup.string().when("main_product", {
      is: (val) => Number(val) !== 9,
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    packagename: yup.string().required("This Field is Required"),
    features: yup.string().required("This Field is Required"),
    amount: yup.number().required("This Field is Required"),
    discount: yup.number().required("This Field is Required"),
    oldprice: yup.number().required("This Field is Required"),
    tagline: yup.string().required("This Field is Required"),
    numberofrevisions: yup.string().required("This Field is Required"),
    concepts: yup.string().required("This Field is Required"),
    // show_pkg: yup.number().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      main_product: initialMainId || "",
      sub_product_id: packageData?.sub_product_id
        ? Number(packageData.sub_product_id)
        : "",
      packagename: packageData?.metas?.packagename || "",
      category: "",
      features: packageData?.features || "",
      amount: "",
      discount: "",
      oldprice: "",
      tagline: "",
      numberofrevisions: "",
      concepts: "",
      show_pkg: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        sub_product_id:
          values.main_product !== 9 ? Number(values.sub_product_id) : 9,
        packagename: values.packagename,
        category: values.main_product !== 9 ? Number(values.sub_product_id) : 9,
        features: values.features,
        amount: Number(values.amount),
        discount: Number(values.discount),
        oldprice: Number(values.oldprice),
        tagline: values.tagline,
        numberofrevisions: Number(values.numberofrevisions),
        concepts: Number(values.concepts),
        // show_pkg: Number(values.show_pkg),
      };

      console.log("data ", data);

      try {
        const url = packageData?.packageid
          ? `packages/update-package/${packageData?.packageid}`
          : "packages/add-package";
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        onSubmit(apiRes?.message || "Deal saved successfully");
        formik.resetForm();
        onClose();
      } catch (error) {
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const loadPackages = async (subProductId) => {
    if (!subProductId) {
      setPackages([]);
      return;
    }
    setLoadingPackages(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (err) {
      console.warn("Error loading packages:", err);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
  };

  const handleMainSelect = async (option) => {
    console.log("Handle Main Select calling", option);

    const id = option || "";

    formik.setFieldValue("main_product", id);
    formik.setFieldValue("sub_product_id", "");
    setSubProducts([]);
    setPackages([]);

    if (id) {
      id == 9 ? await loadPackages(id) : await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option || "";
    formik.setFieldValue("sub_product_id", id);
    setPackages([]);

    if (id) {
      await loadPackages(id);
    }
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid),
      ) === i,
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));

  const editMainId = metas?.main_product ? Number(metas.main_product) : null;
  const editSubId = packageData?.sub_product_id
    ? Number(packageData.sub_product_id)
    : null;
  const editPackageId = packageData?.deal_package
    ? Number(packageData.deal_package)
    : null;

  useEffect(() => {
    let mounted = true;
    const runPrefill = async () => {
      try {
        if (editMainId) {
          formik.setFieldValue("main_product", editMainId, false);

          await loadSubProducts(editMainId);
        }

        if (editSubId) {
          const existsInSub = subProducts.some(
            (sp) =>
              Number(sp.id ?? sp.subproductid ?? sp.productid) ===
              Number(editSubId),
          );
          if (!existsInSub) {
            setSubProducts((prev) => {
              const merged = [
                ...prev,
                {
                  id: editSubId,
                  products:
                    // packageData?.deal_product_name || `Product #${editSubId}`,
                    packageData?.sub_product_id || `Product #${editSubId}`,
                },
              ];
              // ✅ remove duplicates by id/subproductid/productid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) =>
                      Number(t.id ?? t.subproductid ?? t.productid) ===
                      Number(v.id ?? v.subproductid ?? v.productid),
                  ) === i,
              );
              return unique;
            });
          }

          formik.setFieldValue("sub_product_id", editSubId, false);

          await loadPackages(editSubId);

          if (editPackageId) {
            const existsPkg = packages.some(
              (pk) => Number(pk.packageid) === Number(editPackageId),
            );
            if (!existsPkg) {
              setPackages((prev) => {
                const merged = [
                  ...prev,
                  {
                    packageid: editPackageId,
                    packagename: metas?.packagename,
                  },
                ];
                // ✅ remove duplicates by packageid
                const unique = merged.filter(
                  (v, i, a) =>
                    a.findIndex(
                      (t) => Number(t.packageid) === Number(v.packageid),
                    ) === i,
                );
                return unique;
              });
            }

            formik.setFieldValue("deal_package_id", editPackageId, false);

            formik.setFieldValue(
              "deal_package",
              packageData?.deal_package || metas?.deal_package_name || "",
              false,
            );
          }
        } else if (!editSubId && editPackageId) {
          const existsPkg = packages.some(
            (pk) => Number(pk.packageid) === Number(editPackageId),
          );
          if (!existsPkg) {
            setPackages((prev) => {
              const merged = [
                ...prev,
                {
                  packageid: editPackageId,
                  packagename: metas?.packagename,
                },
              ];
              // ✅ remove duplicates by packageid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) => Number(t.packageid) === Number(v.packageid),
                  ) === i,
              );
              return unique;
            });
          }
          formik.setFieldValue("deal_package_id", editPackageId, false);
        }
      } catch (err) {}
    };

    if (packageData) {
      runPrefill();
    }

    return () => {
      mounted = false;
    };
  }, [packageData]);

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Main Product */}

            <FeildWraper width="100%">
              <FormLabel required>Main Product</FormLabel>

              <SelectSearch
                name="main_product"
                placeholder="- Select Main Product -"
                onChange={handleMainSelect}
                value={formik?.values.main_product}
                options={mainOptions}
                onBlur={() =>
                  formik.setFieldTouched("main_product", true, true)
                }
                menuPosition="fixed"
              />
              {formik.touched.main_product && formik.errors.main_product && (
                <FeildError>{formik.errors.main_product}</FeildError>
              )}
            </FeildWraper>

            {/* Sub product */}

            {formik.values.main_product !== 9 ? (
              <FeildWraper>
                <FormLabel required>Sub Product</FormLabel>

                <SelectSearch
                  name="sub_product_id"
                  placeholder={
                    formik.values.main_product
                      ? "- Select Sub Product -"
                      : "Please select a product first"
                  }
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "sub_product_id",
                      selectedOption ? selectedOption.value : "",
                    );
                    handleSubSelect(selectedOption); // if you have custom logic
                  }}
                  value={formik.values?.sub_product_id}
                  isDisabled={!formik.values.main_product}
                  options={subOptions}
                  onBlur={() =>
                    formik.setFieldTouched("sub_product_id", true, true)
                  }
                  menuPosition="fixed"
                />
                {formik.touched.sub_product_id &&
                  formik.errors.sub_product_id && (
                    <FeildError>{formik.errors.sub_product_id}</FeildError>
                  )}
              </FeildWraper>
            ) : null}

            {/*Package name */}

            <FeildWraper
              width={formik.values.main_product == 9 ? `100%` : `50%`}
            >
              <FormLabel required>Package</FormLabel>
              <input
                type="text"
                name="packagename"
                value={formik.values.packagename}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Package Name"
              />

              {formik.touched.packagename && formik.errors.packagename && (
                <FeildError>{formik.errors.packagename}</FeildError>
              )}
            </FeildWraper>

            {/* Amount */}
            <FeildWraper>
              <FormLabel required>Amount</FormLabel>
              <input
                type="number"
                name="amount"
                min="0"
                value={formik.values.amount}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Amount"
              />
              {formik.touched.amount && formik.errors.amount && (
                <FeildError>{formik.errors.amount}</FeildError>
              )}
            </FeildWraper>

            {/* Discount */}
            <FeildWraper>
              <FormLabel required>Discount</FormLabel>
              <input
                type="number"
                name="discount"
                min="0"
                value={formik.values.discount}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Discount"
              />
              {formik.touched.discount && formik.errors.discount && (
                <FeildError>{formik.errors.discount}</FeildError>
              )}
            </FeildWraper>

            {/* old Price */}
            <FeildWraper>
              <FormLabel required>Old Price</FormLabel>
              <input
                type="number"
                name="oldprice"
                min="0"
                value={formik.values.oldprice}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Old Price"
              />
              {formik.touched.oldprice && formik.errors.oldprice && (
                <FeildError>{formik.errors.oldprice}</FeildError>
              )}
            </FeildWraper>

            {/* Tagline */}
            <FeildWraper>
              <FormLabel required>Tag line</FormLabel>
              <input
                type="text"
                name="tagline"
                value={formik.values.tagline}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                max="100"
              />
              {formik.touched.tagline && formik.errors.tagline && (
                <FeildError>{formik.errors.tagline}</FeildError>
              )}
            </FeildWraper>

            {/* concepts */}
            <FeildWraper>
              <FormLabel required>Concepts</FormLabel>
              <input
                type="text"
                name="concepts"
                value={formik.values.concepts}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.touched.concepts && formik.errors.concepts && (
                <FeildError>{formik.errors.concepts}</FeildError>
              )}
            </FeildWraper>

            {/* <FeildWraper>
              <FormLabel required>Show pkg</FormLabel>
              <input
                type="text"
                name="show_pkg"
                value={formik.values.show_pkg}
                onChange={formik.handleChange}
              />
              {formik.touched.show_pkg && formik.errors.show_pkg && (
                <FeildError>{formik.errors.show_pkg}</FeildError>
              )}
            </FeildWraper> */}

            {/* numberofrevisions */}

            <FeildWraper>
              <FormLabel required>Number Of Revisions</FormLabel>
              <input
                type="text"
                name="numberofrevisions"
                value={formik.values.numberofrevisions}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.numberofrevisions &&
                formik.errors.numberofrevisions && (
                  <FeildError>{formik.errors.numberofrevisions}</FeildError>
                )}
            </FeildWraper>

            {/* Features */}
            <FeildWraper width="100%">
              <FormLabel>Features</FormLabel>
              <textarea
                name="features"
                value={formik.values.features}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                rows={6}
                placeholder="Write or edit package features here..."
              />
              {formik.touched.features && formik.errors.features && (
                <FeildError>{formik.errors.features}</FeildError>
              )}
            </FeildWraper>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {packageData?.packageid ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdatePackage;
